export default function (element) {
  if (!element) return;
  element.scrollTop = element.scrollHeight;
}
